import React from "react";
import SystemGraphs from "./SystemGraphs";

const ScadaStationsFull = () => {
  const defaultParameter = 67;

  const pageTitle = "SCADA Stations Full";

  const endpoints = [
    { label: "15 Minutes", value: "display014-data15-min" },
    { label: "Daily", value: "display014-data-daily" },
  ];

  const parametersEndpoint = "display014-lookup-parameter";

  const mapEndpoint = "display014-map-points";

  return (
    <>
      <SystemGraphs
        defaultParameter={defaultParameter}
        pageTitle={pageTitle}
        endpoints={endpoints}
        parametersEndpoint={parametersEndpoint}
        mapEndpoint={mapEndpoint}
      />
    </>
  );
};

export default ScadaStationsFull;
